import { MouseEvent } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from '@emotion/styled';
import ModalActionCreator from 'action_creators/modal';

const CancellationPolicyText = styled.span`
  display: block;
  inline-size: ${(props: { inlineSize?: number }) =>
    props.inlineSize ? `${props.inlineSize}%` : '90%'};
  padding-right: 10px;
  min-width: fit-content;
`;

const PolicyLink = styled.a`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-decoration: underline;
  text-decoration-style: dotted;
  -webkit-line-clamp: 3;
  color: #3d57ff;

  @media only screen and (max-width: 600px) {
    -webkit-line-clamp: 5;
  }

  &:hover {
    color: #263dd6;
  }
`;

const ModalContent = styled.div`
  padding: 20px;
`;

const ModalTitle = styled.div`
  margin-bottom: 10px;
`;

const ModalText = styled.p`
  margin-top: 10px;
  line-height: 1.5;
`;

interface CancellationPolicyProps {
  description: string;
  hasCancellation: boolean;
}

export const CancellationPolicy = ({
  description = '',
  hasCancellation = false,
}: CancellationPolicyProps) => {
  const popupContent = () => {
    return (
      <ModalContent>
        <ModalTitle>
          <FormattedMessage
            defaultMessage="Cancellation policy"
            description="Cancellation policy"
          />
        </ModalTitle>
        <hr />
        <ModalText>{description}</ModalText>
      </ModalContent>
    );
  };

  const showPopup = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    ModalActionCreator.show({
      content: popupContent(),
      triggeringElement: e.currentTarget,
      className: 'small CancellationPolicy-Modal',
    });
  };

  return (
    <div className="CheckoutSummary-ContentBox Cancellation-Policy">
      <table className="section">
        <tbody>
          <tr>
            <td>
              <CancellationPolicyText>
                <FormattedMessage
                  defaultMessage="Cancellation policy"
                  description="Cancellation policy"
                />
              </CancellationPolicyText>
            </td>
            <td>
              {hasCancellation ? (
                <PolicyLink
                  href="#"
                  onClick={showPopup}
                  data-testid="cancellation-policy-in-checkout-card"
                >
                  {description}
                </PolicyLink>
              ) : (
                <FormattedMessage
                  defaultMessage="No cancellations"
                  description="No cancellations"
                />
              )}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
